export const Logo = ({ dark = false }) => (
  <div className="flex items-center gap-2.5" data-testid="logo-fodindinca">
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 29C17 29 5 21.5 5 12.8C5 8.2 8.6 5 12.5 5C14.4 5 16 5.9 17 7.2C18 5.9 19.6 5 21.5 5C25.4 5 29 8.2 29 12.8C29 21.5 17 29 17 29Z"
        fill="#E05638"
      />
      <path d="M17 29C17 29 5 21.5 5 12.8C5 8.2 8.6 5 12.5 5C14.4 5 16 5.9 17 7.2V29Z" fill="#0A5C36" />
      <circle cx="17" cy="13.5" r="3" fill="#D4AF37" />
    </svg>
    <span
      className={`font-heading text-xl font-extrabold tracking-tight ${dark ? "text-stone-100" : "text-stone-900"}`}
    >
      Fodindin<span className="text-[#E05638]">Ca</span>
    </span>
  </div>
);
